import { useState } from "react";
import { AlertCircle, Send } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";
import { useToast } from "@/hooks/use-toast";

export function EmailVerificationBanner() {
  const { user } = useAuth();
  const { toast } = useToast();
  const [sending, setSending] = useState(false);

  if (!user || user.emailVerified !== false) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      const token = localStorage.getItem("ayrshire_token");
      await fetch("/api/auth/resend-verification", {
        method: "POST",
        headers: { Authorization: `Bearer ${token ?? ""}` },
      });
      toast({ title: "Verification email sent", description: "Check your inbox — and your spam/junk folder too." });
    } catch {
      toast({ title: "Could not send email", description: "Please try again shortly.", variant: "destructive" });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-amber-500 px-4 py-3 flex items-center gap-3 text-sm text-white">
      <AlertCircle className="h-4 w-4 shrink-0" />
      <span className="flex-1 font-medium">
        Your email address isn't verified yet — you won't be able to upload images or post until you do.
        Check your inbox (and <strong>spam/junk folder</strong>) for the verification link.{" "}
        <button
          onClick={handleResend}
          disabled={sending}
          className="underline font-semibold hover:opacity-80 disabled:opacity-50 inline-flex items-center gap-1"
        >
          <Send className="h-3 w-3" />
          {sending ? "Sending…" : "Resend email"}
        </button>
      </span>
    </div>
  );
}
